import { useComponentTheme } from '../hooks/UNSAFE_useComponentTheme';
import { InlineHelpSource } from './InlineHelpSource';
import {
  UserAssistanceStyles,
  UserAssistanceVariantOptions
} from './themes/UserAssistanceStyles.css';
import { UserAssistanceRedwoodTheme } from './themes/redwood/UserAssistanceTheme';

type Props = {
  assistiveText?: string;
  sourceLink?: string;
  sourceText?: string;
};

export function InlineHelp({ assistiveText, sourceLink, sourceText }: Props) {
  const {
    styles: { helpTextStyles }
  } = useComponentTheme<UserAssistanceVariantOptions, UserAssistanceStyles>(
    UserAssistanceRedwoodTheme
  );
  return (
    <>
      {assistiveText && sourceLink ? (
        <span class={helpTextStyles}>{assistiveText}</span>
      ) : (
        assistiveText
      )}
      {sourceLink && <InlineHelpSource source={sourceLink}>{sourceText}</InlineHelpSource>}
    </>
  );
}
